// extracted by mini-css-extract-plugin
module.exports = {"cookie_banner_overlay":"Popup_cookie_banner_overlay__vM8Ku","cookie_banner":"Popup_cookie_banner__Yip7u","logo":"Popup_logo__oU15Z","subtitle":"Popup_subtitle__KivLV"};